import { RegistrationValues, User } from "../types/auth.type";
import { api } from "./config/axios";

const API_URL = `${process.env.GATSBY_BACKEND_URL}/`;

class AuthService {
  login = async (username: string, password: string) => {
    const response = await api.post(API_URL + "auth/login/", {
      username,
      password,
    });

    return response.data;
  };

  logout = async (refresh: string) => {
    const response = await api.post(API_URL + "auth/logout/", {
      refresh: refresh,
    });

    return response.data;
  };

  refresh = async (refresh: string) => {
    const response = await api.post(API_URL + "auth/token/refresh/", {
      refresh: refresh,
    });

    return response.data;
  };

  register = async (details: RegistrationValues) => {
    const response = await api.post(API_URL + "auth/register/", {
      username: details.username,
      first_name: details.firstname,
      last_name: details.lastname,
      email: details.email,
      password: details.password,
    });

    return response.data;
  };

  forgotPassword = async (email: string) => {
    const response = await api.post(API_URL + "auth/password-reset/", {
      email: email,
    });

    return response.data;
  };

  resetPassword = async (password: string, token: string, uid: string) => {
    const response = await api.post(API_URL + "auth/password-reset-confirm/", {
      new_password: password,
      token: token,
      uid: uid,
    });

    return response.data;
  };

  getUser = async () => {
    const response = await api.get(API_URL + "auth/user/", {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  };

  updateUser = async (userData: Partial<User>) => {
    const response = await api.patch(API_URL + "auth/user/", userData, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  };

  usernameExists = async (username: string) => {
    const response = await api.get(API_URL + `auth/username-exists/`, {
      headers: {
        "Content-Type": "application/json",
      },
      params: {
        username: username,
      },
    });

    return response.data;
  };
}

export const AuthAPI = new AuthService();
